import React from "react";
import image1 from "../img/Conditions to bloom in Winter part 033 && What remains of the snow---Interweaving of textured layers in Adobe Photoshop over curated, AI-generated visuals___2025-06[[4]].jpg"
export default function Machine_1_2_7() {
  return (
    <div className="panel-block">
      

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1.2.7 · ORDER & CHAOS"
        />
      </div>

      <div className="panel-container-right">
        <h2>1.2.7 · ORDER & CHAOS</h2>
        <p>Not opposites.</p>
    <p>Functions.</p>
    <p>Order stabilizes the pattern.</p>
    <p>Chaos introduces variation.</p>
    <p>Too much Order freezes the Cycle.</p>
    <p>Too much Chaos erases it.</p>
    <p>The Machine requires both to continue adjusting.</p>
      </div>
    </div>
  );
}
